import { Notify } from '~/components2/Notify';

export function notifyExportError() {
  Notify.error({
    title: '⚠️',
    message: 'There was an error during the export process. Please try again or contact support.',
  });
}
